import React from 'react';

const CommentFilters = ({ filters, onFilterChange, articles, loading }) => {
  const sortOptions = [
    { value: 'newest', label: 'Nyeste først' },
    { value: 'oldest', label: 'Eldste først' },
    { value: 'most_liked', label: 'Mest likt' },
  ];

  const inputStyle = {
    background: 'rgba(255,255,255,0.04)',
    border: '1px solid rgba(255,255,255,0.1)',
    color: '#EEF0F2',
    fontFamily: 'JetBrains Mono, monospace',
    fontSize: '0.7rem',
    padding: '8px 12px',
    outline: 'none',
    width: '100%',
    letterSpacing: '0.05em',
  };

  const labelStyle = {
    fontFamily: 'JetBrains Mono, monospace',
    fontSize: '0.55rem',
    color: '#3B6FD4',
    letterSpacing: '0.15em',
    textTransform: 'uppercase',
    display: 'block',
    marginBottom: '6px',
  };

  return (
    <div style={{
      background: 'rgba(255,255,255,0.02)',
      border: '1px solid rgba(255,255,255,0.06)',
      padding: '20px 24px',
      marginBottom: '32px',
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
      gap: '16px',
      alignItems: 'end',
    }}>
      {/* Date from */}
      <div>
        <label style={labelStyle}>FRA DATO</label>
        <input
          type="date"
          value={filters?.dateFrom || ''}
          onChange={e => onFilterChange?.({ ...filters, dateFrom: e?.target?.value })}
          style={{ ...inputStyle, colorScheme: 'dark' }}
        />
      </div>
      {/* Date to */}
      <div>
        <label style={labelStyle}>TIL DATO</label>
        <input
          type="date"
          value={filters?.dateTo || ''}
          onChange={e => onFilterChange?.({ ...filters, dateTo: e?.target?.value })}
          style={{ ...inputStyle, colorScheme: 'dark' }}
        />
      </div>
      {/* Article filter */}
      <div>
        <label style={labelStyle}>ARTIKKEL</label>
        <select
          value={filters?.articleId || ''}
          onChange={e => onFilterChange?.({ ...filters, articleId: e?.target?.value })}
          style={{ ...inputStyle, cursor: 'pointer' }}
          disabled={loading}
        >
          <option value="">Alle artikler</option>
          {articles?.map(a => (
            <option key={a?.id} value={a?.id}>{a?.title?.length > 40 ? `${a?.title?.slice(0, 40)}…` : a?.title}</option>
          ))}
        </select>
      </div>
      {/* Sort */}
      <div>
        <label style={labelStyle}>SORTER</label>
        <select
          value={filters?.sort || 'newest'}
          onChange={e => onFilterChange?.({ ...filters, sort: e?.target?.value })}
          style={{ ...inputStyle, cursor: 'pointer' }}
        >
          {sortOptions?.map(o => (
            <option key={o?.value} value={o?.value}>{o?.label}</option>
          ))}
        </select>
      </div>
      {/* Reset */}
      <div>
        <button
          onClick={() => onFilterChange?.({ dateFrom: '', dateTo: '', articleId: '', sort: 'newest' })}
          style={{
            background: 'none',
            border: '1px solid rgba(255,255,255,0.12)',
            color: 'rgba(238,240,242,0.5)',
            fontFamily: 'JetBrains Mono, monospace',
            fontSize: '0.6rem',
            padding: '8px 16px',
            cursor: 'pointer',
            letterSpacing: '0.1em',
            width: '100%',
            textTransform: 'uppercase',
            transition: 'all 0.2s',
          }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = '#3B6FD4'; e.currentTarget.style.color = '#3B6FD4'; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.12)'; e.currentTarget.style.color = 'rgba(238,240,242,0.5)'; }}
        >
          NULLSTILL
        </button>
      </div>
    </div>
  );
};

export default CommentFilters;
